import { Dispatch } from "redux";
import PunctualCourseRepository from "../../Repositories/PunctualCourseRepository";
// import { updatePaginationInterface } from "../../Objects/interfaces/AppInterface";
// import { updatePaginationState } from "../../Screens/Teacher/Admin/Dashboard/Utils/Function";
// import SubjectRepository from "../../Repositories/SubjectRepository";
// import { SHOW_INFO_AUTH } from "../Reducers/MessageReducers";
import ActionInterface from "../../Objects/interfaces/ActionInterface";
import Teachr_Repository from "../../Repositories/Teachr_Repository";
// import { useSelector } from "react-redux";
import Teachr from "../../Objects/models/Teachr";
// import { computeTotalHours } from "../../Hooks/Dashboard/useHome";

export const GET_ACTIVE_COURSE = "GET_ACTIVE_COURSE";
export const GET_PENDING_COURSE = "GET_PENDING_COURSE";
export const GET_NEXT_COURSE = "GET_NEXT_COURSE";
export const GET_PAST_COURSE = "GET_PAST_COURSE";
export const GET_INFO_CHART = "GET_INFO_CHART";
export const GET_AMOUNT_DURATION = "GET_AMOUNT_DURATION";
export const GET_SUBJECT = "GET_SUBJECT";
export const RESET_ACTIVE_COURSE = "RESET_ACTIVE_COURSE";
export const RESET_PENDING_COURSE = "RESET_PENDING_COURSE";
export const RESET_NEXT_COURSE = "RESET_NEXT_COURSE";
export const RESET_PAST_COURSE = "RESET_PAST_COURSE";
export const RESET_INFO_CHART = "RESET_INFO_CHART";
export const RESET_AMOUNT_DURATION = "RESET_AMOUNT_DURATION";
export const RESET_SUBJECT = "RESET_SUBJECT";
export const DELETE_COURSE = "DELETE_COURSE";

interface GetActiveCourseAction {
  type: typeof GET_ACTIVE_COURSE;
  payload: any;
}
interface GetPendingCourseAction {
  type: typeof GET_PENDING_COURSE;
  payload: any;
}
interface GetNextCourseAction {
  type: typeof GET_NEXT_COURSE;
  payload: any;
}
interface GetPastCourseAction {
  type: typeof GET_PAST_COURSE;
  payload: any;
}
interface GetAmountAndDurationAction {
  type: typeof GET_AMOUNT_DURATION;
  payload: any;
}
interface GetInfoChartAction {
  type: typeof GET_INFO_CHART;
  payload: any;
}
interface GetSubjectAction {
  type: typeof GET_SUBJECT;
  payload: any;
}

export type GetActiveCourseActionTypes = GetActiveCourseAction;
export type GetPendingCourseActionTypes = GetPendingCourseAction;
export type GetNextCourseActionTypes = GetNextCourseAction;
export type GetPastCourseActionTypes = GetPastCourseAction;
export type GetInfoChartActionTypes = GetInfoChartAction;
export type GetAmountAndDurationActionTypes = GetAmountAndDurationAction;
export type GetSubjectActionTypes = GetSubjectAction;

export const getPendingCourse = (data: any) => {
  return async (dispatch: Dispatch<GetPendingCourseActionTypes | any>) => {
    try {
      if (!data.global.teachr?.id) return;
      const courses = await PunctualCourseRepository.getPendingPunctualCourseByTeachr(data.global.teachr?.id, data.currentPagePending, data.limitPending)

      dispatch({ type: GET_PENDING_COURSE, payload: courses });
    } catch (error) {
      console.error("Erreur lors de la récupération des cours prévu :", error);
    }
  };
};
export const getActiveCourse = (data: any) => {
  return async (dispatch: Dispatch<GetActiveCourseActionTypes | any>) => {
    try {
      if (!data.global.teachr?.id) return;
      const courses = await PunctualCourseRepository.getPunctualCourseByTeachr(data.global.teachr?.id, data.currentPage, data.limit)
      
      dispatch({ type: GET_ACTIVE_COURSE, payload: courses });
    } catch (error) {
      console.error("Erreur lors de la récupération des cours actives :", error);
      
    }
  };
};
export const getNextCourse = (data: any) => {
  return async (dispatch: Dispatch<GetNextCourseActionTypes | any>) => {
    try {
      if (!data.global.teachr?.id) return;
      const courses = await PunctualCourseRepository.getCourseNextMonth(data.global.teachr?.id, !data.currentPageNext ? 0 : data.currentPageNext, data.limitNext)
      dispatch({ type: GET_NEXT_COURSE, payload: courses });
    } catch (error) {
      console.error("Erreur lors de la récupération des prochains cours :", error);
    }
  };
};
export const getPastCourse = (data: any) => {
  return async (dispatch: Dispatch<GetPastCourseActionTypes | any>) => {
    try {
      if (!data.global.teachr?.id) return;
      const courses = await PunctualCourseRepository.searchPunctualCoursePastByTeachrNew(data.currentPagePast, data.global.teachr?.id, data.global.nameSearch ? data.global.nameSearch : "", data.global.subjectSearch, data.global.startDateSearch, data.global.endDateSearch, data.limitPast)

      dispatch({ type: GET_PAST_COURSE, payload: courses });
    } catch (error) {
      console.error("Erreur lors de la récupération des cours passés :", error);
      // dispatch({
      //   type: SHOW_INFO_AUTH, payload: ""
      // })
    }
  };
};
export const getInfoChart = (data: any) => {
  return async (dispatch: Dispatch<GetInfoChartActionTypes | any>) => {
    try {
      if (!data.global.teachr?.id) return;
      const infos = await PunctualCourseRepository.retreivePaidAmountInChart(data.global.teachr?.id, data?.type)
      dispatch({ type: GET_INFO_CHART, payload: infos });
    } catch (error) {
      console.error("Erreur lors de la récupération des infos pour les graphs :", error);
    }
  };
};
export const getAmountAndDuration = (teachr: Teachr | undefined) => {
  return async (dispatch: Dispatch<GetAmountAndDurationActionTypes | any>) => {
    try {
      if (!teachr?.id) return;
      const infos = await PunctualCourseRepository.retreivePaidAmountInChart(teachr?.id, "startTeach")
      dispatch({ type: GET_AMOUNT_DURATION, payload: infos });
    } catch (error) {
      console.error("Erreur lors de la récupération les durées et amount :", error);
    }
  };
};
export const getSubject = (teachr: number) => {
  return async (dispatch: Dispatch<GetSubjectAction | any>) => {
    try {
      if (!teachr) return;
      Teachr_Repository.getSubjectsGivenByTeachr(teachr).then((response) => {
        if (response) {
          dispatch({ type: GET_SUBJECT, payload: JSON.parse(JSON.stringify(response)) });
        }
      }).catch((error) => {
        console.error("Erreur lors de la récupération des matières :", error);
      })
    } catch (error) {
      // console.error("test", error);
      // dispatch({
      //   type: SHOW_INFO_AUTH, payload: ""
      // })
    }
  };
};


export const resetActiveCourseAction = (): ActionInterface => {
  return {
    type: RESET_ACTIVE_COURSE,
    value: null,
  };
};

export const resetPastCourseAction = (): ActionInterface => {
  return {
    type: RESET_PAST_COURSE,
    value: null,
  };
};
export const resetInfoChartAction = (): ActionInterface => {
  return {
    type: RESET_INFO_CHART,
    value: null,
  };
};

export const resetNextCourseAction = (): ActionInterface => {
  return {
    type: RESET_NEXT_COURSE,
    value: null,
  };
};
export const resetPendingCourseAction = (): ActionInterface => {
  return {
    type: RESET_PENDING_COURSE,
    value: null,
  };
};
export const resetAmountDurationAction = (): ActionInterface => {
  return {
    type: RESET_AMOUNT_DURATION,
    value: null,
  };
};
export const resetSubjectAction = (): ActionInterface => {
  return {
    type: RESET_SUBJECT,
    value: null,
  };
};

